// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const clinicRequirementsService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/ClinicRequirements`, { headers });
  },

  getActive: async () => {
    return await axios.get(`${domain}/api/ClinicRequirements/active`, { headers });
  },
  
  getById: async (id) => {
    return await axios.get(`${domain}/api/ClinicRequirements/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/ClinicRequirements`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/ClinicRequirements/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/ClinicRequirements/${id}`, { headers });
  },
};

export default clinicRequirementsService;